var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            "append-to-body": true,
            "before-close": _vm.handleClose,
            modal: true,
            title: !!this.editId && this.editType ? _vm.newTitle : _vm.title,
            visible: _vm.drawer,
            "wrapper-closable": true,
            wrapperClosable: _vm.editType ? true : false,
            direction: "rtl",
            size: "920px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "invoice-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    !!this.editId && this.editType ? _vm.newTitle : _vm.title
                  )
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "time" }, [
                _vm._v(_vm._s(_vm.editData.created_at || "")),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "rollBottom",
              staticClass: "form-box mt20",
              class: _vm.isShow ? "pb-120" : "",
              style: "height:" + _vm.rollHeight + "px;",
            },
            [
              _c(
                "div",
                { staticClass: "report" },
                [
                  _c("div", { staticClass: "title" }, [_vm._v("汇报给")]),
                  _vm._v(" "),
                  _c("select-member", {
                    ref: "selectMember",
                    staticStyle: { width: "100%" },
                    attrs: { value: _vm.examineData },
                    on: { getSelectList: _vm.getSelectList },
                    scopedSlots: _vm._u([
                      {
                        key: "custom",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              { staticClass: "flex-user" },
                              [
                                !_vm.disabled
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "addPeople",
                                        on: { click: _vm.handlesuperiorOpen },
                                      },
                                      [
                                        _c("span", {
                                          staticClass: "iconfont icontianjia",
                                        }),
                                        _vm._v("添加\n              "),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(_vm.examineData, function (item, index) {
                                  return _c(
                                    "div",
                                    { key: index, staticClass: "user" },
                                    [
                                      _c("img", {
                                        staticClass: "img",
                                        attrs: {
                                          src: item ? item.avatar : item.avatar,
                                          alt: "",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(" " + _vm._s(item.name || "--")),
                                      ]),
                                      _vm._v(" "),
                                      !_vm.disabled
                                        ? _c("span", {
                                            staticClass: "iconfont iconcha",
                                            on: {
                                              click: function ($event) {
                                                return _vm.userDelete(item)
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  )
                                }),
                              ],
                              2
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.report_show ? 24 : 12 } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "today-work",
                              class: !_vm.disabled ? "border" : "",
                            },
                            [
                              _vm.needList.length &&
                              !_vm.disabled &&
                              !_vm.editId
                                ? _c(
                                    "el-form-item",
                                    {
                                      staticClass: "item-bar today-bar-list",
                                      attrs: {
                                        label: _vm.title01,
                                        prop: "finish",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        ref: "finish",
                                        attrs: {
                                          disabled: _vm.disabled,
                                          maxlength: 2000,
                                          autosize: "",
                                          resize: "none",
                                          "show-word-limit": "",
                                          type: "textarea",
                                        },
                                        on: {
                                          change: _vm.changeSize,
                                          input: _vm.changeSize,
                                        },
                                        model: {
                                          value: _vm.ruleForm.finish,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "finish",
                                              $$v
                                            )
                                          },
                                          expression: "ruleForm.finish",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.needList.length &&
                                      !_vm.disabled &&
                                      !_vm.editId
                                        ? _c("div", { staticClass: "todo" }, [
                                            _c(
                                              "div",
                                              { staticClass: "title" },
                                              [
                                                _vm._v(
                                                  "\n                    未完成待办\n                    "
                                                ),
                                                _c("span", [
                                                  _vm._v(
                                                    "（点击生成今日完成事项）"
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "todo-list" },
                                              _vm._l(
                                                _vm.needList,
                                                function (item, index) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: index,
                                                      staticClass: "item",
                                                    },
                                                    [
                                                      item.finish === 0 ||
                                                      item.finish === 1 ||
                                                      item.finish === -1
                                                        ? _c("i", {
                                                            staticClass:
                                                              "dealt-icon",
                                                            class: item.checked
                                                              ? "checked el-icon-check"
                                                              : "square",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.setScheduleRecord(
                                                                  item,
                                                                  3,
                                                                  index
                                                                )
                                                              },
                                                            },
                                                          })
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(item.title)
                                                        ),
                                                      ]),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ])
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _c(
                                    "el-form-item",
                                    {
                                      staticClass: "item-bar today-bar",
                                      attrs: {
                                        label: _vm.title01,
                                        prop: "finish",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        ref: "finish",
                                        attrs: {
                                          disabled: _vm.disabled,
                                          maxlength: 2000,
                                          autosize: "",
                                          resize: "none",
                                          "show-word-limit": "",
                                          type: "textarea",
                                        },
                                        on: {
                                          change: _vm.changeSize,
                                          input: _vm.changeSize,
                                        },
                                        model: {
                                          value: _vm.ruleForm.finish,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "finish",
                                              $$v
                                            )
                                          },
                                          expression: "ruleForm.finish",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      !_vm.report_show
                        ? _c("el-col", { attrs: { span: 12 } }, [
                            _c(
                              "div",
                              {
                                staticClass: "item-bar-box",
                                class: !_vm.disabled ? "border" : "",
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "item-bar",
                                    attrs: { label: _vm.title02, prop: "plan" },
                                  },
                                  [
                                    _c("el-input", {
                                      ref: "plan",
                                      attrs: {
                                        disabled: _vm.disabled,
                                        maxlength: 2000,
                                        autosize: "",
                                        resize: "none",
                                        "show-word-limit": "",
                                        type: "textarea",
                                      },
                                      on: {
                                        change: _vm.changeSize,
                                        input: _vm.changeSize,
                                      },
                                      model: {
                                        value: _vm.ruleForm.plan,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.ruleForm, "plan", $$v)
                                        },
                                        expression: "ruleForm.plan",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.editType || _vm.ruleForm.mark
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "m-b-30 m-t-20",
                          attrs: { label: _vm.$t("public.remarks") },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.disabled,
                              rows: 4,
                              resize: "none",
                              type: "textarea",
                            },
                            on: { change: _vm.updateValue },
                            model: {
                              value: _vm.ruleForm.mark,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "mark", $$v)
                              },
                              expression: "ruleForm.mark",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.attachList.length ||
                  (!_vm.attachList.length && !_vm.editType)
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "m-b-30",
                          attrs: {
                            label:
                              _vm.attachList.length ||
                              (!_vm.attachList.length && !_vm.editType)
                                ? "附件"
                                : "",
                          },
                        },
                        [
                          _c("upload-file", {
                            staticClass: "upload-file",
                            attrs: {
                              "file-list": _vm.attachList,
                              fileWidth: "420px",
                              params: _vm.fileParams,
                              "show-close": !_vm.editId || !_vm.editType,
                              editType: "editType",
                              url: "/system/attach/upload",
                            },
                            on: { "on-success": _vm.handleSuccess },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _vm.editId && _vm.editType
                ? _c(
                    "div",
                    { staticClass: "list" },
                    _vm._l(_vm.replyList, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "item acea-row row-between",
                          class: item.paent_user ? "parent-replay" : "",
                        },
                        [
                          item.card.avatar
                            ? _c("el-avatar", {
                                attrs: { size: 38, src: item.card.avatar },
                              })
                            : _c("el-avatar", {
                                attrs: { size: 38, icon: "el-icon-user-solid" },
                              }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "pictxt",
                              class: { "parent-replay-text": item.paent_user },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "name acea-row row-between-wrapper",
                                },
                                [
                                  item.paent_user
                                    ? _c("div", [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(item.card.name)
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "created-at" },
                                          [_vm._v(_vm._s(item.created_at))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "acea-row reply" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "keyword" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("public.reply")
                                                  ) +
                                                    _vm._s(
                                                      item.paent_user.card.name
                                                    ) +
                                                    ":"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "reply-text" },
                                              [_vm._v(_vm._s(item.content))]
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _c("div", [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(item.card.name)
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "created-at" },
                                          [_vm._v(_vm._s(item.created_at))]
                                        ),
                                      ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text acea-row row-between-wrapper",
                                },
                                [
                                  !item.paent_user
                                    ? _c("div", { staticClass: "textCon" }, [
                                        _vm._v(_vm._s(item.content)),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.card.uid === _vm.uid
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "reply",
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteReply(
                                                item.id,
                                                item.daily_id,
                                                index
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.$t("public.delete")) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass: "reply",
                                          on: {
                                            click: function ($event) {
                                              return _vm.replyBnt(item)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("public.reply")))]
                                      ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "from-foot-btn fix btn-shadow" },
            [
              _vm.isShow
                ? _c("div", { staticClass: "flex" }, [
                    _c("img", {
                      staticClass: "avatar",
                      attrs: { src: _vm.avatar, alt: "" },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "replyCon" },
                      [
                        _c("el-input", {
                          ref: "replyInput",
                          staticClass: "replyText",
                          attrs: {
                            placeholder: _vm.textPla,
                            resize: "none",
                            type: "textarea",
                          },
                          model: {
                            value: _vm.reply.content,
                            callback: function ($$v) {
                              _vm.$set(_vm.reply, "content", $$v)
                            },
                            expression: "reply.content",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "bnt" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "small" },
                                on: { click: _vm.cancel },
                              },
                              [_vm._v(_vm._s(_vm.$t("public.cancel")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: { size: "small", type: "primary" },
                                on: { click: _vm.submitReply },
                              },
                              [_vm._v("提交")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ])
                : [
                    !_vm.disabled
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "small" },
                            on: { click: _vm.closeBtn },
                          },
                          [_vm._v(_vm._s(_vm.$t("public.cancel")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.editId && _vm.disabled
                      ? _c(
                          "div",
                          { staticClass: "flex", on: { click: _vm.evaluate } },
                          [
                            _c("img", {
                              staticClass: "avatar",
                              attrs: { src: _vm.avatar, alt: "" },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "replyCon-no" }, [
                              _vm._v("添加评论"),
                            ]),
                          ]
                        )
                      : _c(
                          "el-button",
                          {
                            attrs: {
                              loading: _vm.saveLoading,
                              size: "small",
                              type: "primary",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.submitForm("ruleForm")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("public.save")) +
                                "\n        "
                            ),
                          ]
                        ),
                  ],
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }